<template>
    <div v-if="showReschedule">
        <CreateRescheduleRequest :classDetails="classDetails" :conflicts="rescheduleConflicts" @submit-request="submitReschedule" />
    </div>
    <div v-else>
        <!-- <div class="back-section flex flex-wrap align-self-start pt-2">
            <Button icon="pi pi-arrow-left" label="Back" class="p-button-text Caption back-button mb-2 "
                @click="$emit('back')" />
        </div> -->
        <div v-if="loading" class="card flex justify-content-center">
            <ProgressSpinner />
        </div>
        <div v-else-if="classDetails" class="grid flex flex-column p-4">
            <div class="flex justify-content-between align-items-center mb-4">
                <h3 class="text-lg Paragraph-Medium m-0">Class Details</h3>
                <Button v-if="!isInstitute" label="Reschedule Class" class="teal-button-small align-self-start" style="margin-top: -70px; margin-right: 20px;" @click="showReschedule = true" />
            </div>

            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Subject –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.subject) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Date –</span>
                        <span class="Paragraph-Regular">{{ classDetails.date }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Grade –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.grade) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Class Type –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classType) }}</span>
                    </div>
                    <div class="detail-item meet-link-item" v-if="classDetails.meetLink">
                        <span class="Paragraph-Medium meet-link-label">Google Meet –</span>
                        <div class="meet-link-box">
                            <a :href="classDetails.meetLink" target="_blank" rel="noopener noreferrer" class="meet-link">{{ classDetails.meetLink }}</a>
                            <button class="copy-btn" @click="copyMeetLink(classDetails.meetLink)" :title="copied ? 'Copied!' : 'Copy link'">
                                <i :class="copied ? 'pi pi-check' : 'pi pi-copy'"></i>
                            </button>
                        </div>
                    </div>
                    <div class="detail-item" v-if="classDetails.classLocation">
                        <span class="Paragraph-Medium">Location –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classLocation) }}</span>
                    </div>
                    <div class="detail-item text-justify" v-if="classDetails.areasToImprove">
                        <span class="Paragraph-Medium">Specific areas want to improve -</span>
                        <span class="Paragraph-Regular">{{ classDetails.areasToImprove }}</span>
                    </div>
                    <div class="detail-item text-justify" v-if="classDetails.note">
                        <span class="Paragraph-Medium">Additional Note –</span>
                        <span class="Paragraph-Regular">{{ classDetails.note }}</span>
                    </div>

                    <div v-if="classDetails.recurrence && classDetails.recurrence.enabled" class="mt-4">
                        <div class="recurrence-grid">
                            <div class="Paragraph-Medium text-nowrap">Recurrence Classes -</div>
                            <div class="Paragraph-Regular"> Repeat every {{ classDetails.recurrence.repeatWeeks }} week
                            </div>
                            <div></div>
                            <div class="flex align-items-center">
                                <span class="Paragraph-Regular mr-2">Repeat on</span>
                                <div class="flex gap-2">
                                    <div v-for="day in classDetails.recurrence.repeatOn" :key="day" class="day-circle">
                                        {{ getShortDayName(day) }} </div>
                                </div>
                            </div>
                            <div></div>
                            <div class="Paragraph-Regular">Class Occurs {{ classDetails.recurrence.totalOccurrences }}
                                times</div>
                            <div></div>
                            <div class="Paragraph-Regular">Ends after {{ classDetails.recurrence.totalOccurrences *
                                classDetails.recurrence.repeatWeeks }} week </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 md:col-6">
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Language –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.language) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Time –</span>
                        <span class="Paragraph-Regular">{{ classDetails.start }} - {{ classDetails.end }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Class Model –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classModel) }}</span>
                    </div>
                    <div class="detail-item flex gap-2"
                        v-if="classDetails.otherStudents && classDetails.otherStudents.length">
                        <span class="Paragraph-Medium whitespace-nowrap">Other Students –</span>
                        <div class="flex flex-column">
                            <span v-for="student in classDetails.otherStudents" :key="student"
                                class="Paragraph-Regular">
                                {{ student }}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item" v-if="classDetails.sessionFee != null">
                        <span class="Paragraph-Medium">Session Fee –</span>
                        <span class="Paragraph-Regular">{{ formatFee(classDetails.sessionFee) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Payment –</span>
                        <span class="Paragraph-Regular">{{ classDetails.isPaid ? 'Completed' : 'Pending' }}</span>
                        <span class="Caption" v-if="!classDetails.isPaid">( Please complete your payment to unlock this session )</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Could not load class details.</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps, computed } from 'vue';
import { fetchClassInstanceDetails, createRescheduleRequest } from '@/api/tutor';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import { notifyError, notifySuccess } from '@/utils/notification';
import { cleanupLables } from "@/utils/cleanups";
import CreateRescheduleRequest from './createRescheduleRequest.vue';
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();
const isInstitute = computed(() => authStore.user?.role === 'institute');

const copied = ref(false);
const copyMeetLink = (link) => {
    navigator.clipboard.writeText(link);
    copied.value = true;
    setTimeout(() => { copied.value = false; }, 2000);
};

const formatFee = (fee) => {
    return `Rs.${Number(fee).toFixed(2)}`;
};

const getShortDayName = (day) => {
    const map = {
        'monday': 'M',
        'tuesday': 'Tu',
        'wednesday': 'W',
        'thursday': 'Th',
        'friday': 'F',
        'saturday': 'Sa',
        'sunday': 'Su'
    };
    return map[day] || day.substring(0, 2);
};

const props = defineProps({
    classInstanceId: {
        type: String,
        required: true,
    },
});

defineEmits(['back']);

const loading = ref(true);
const classDetails = ref(null);
const showReschedule = ref(false);
const rescheduleConflicts = ref({ message: '', items: [] });

const fetchDetails = async () => {
    try {
        loading.value = true;
        const response = await fetchClassInstanceDetails(props.classInstanceId);
        classDetails.value = response.data.data;
    } catch (error) {
        notifyError('Error fetching class details', error.message);
        console.error(error);
    } finally {
        loading.value = false;
    }
};

const submitReschedule = async (payload) => {
    rescheduleConflicts.value = { message: '', items: [] };
    try {
        loading.value = true;
        await createRescheduleRequest({ instanceId: props.classInstanceId, ...payload });
        notifySuccess('Success', 'Reschedule request sent successfully');
        showReschedule.value = false;
        fetchDetails();
    } catch (error) {
        console.error(error);
        loading.value = false;
        if (error.response?.data?.status === 409 || error.response?.status === 409) {
            rescheduleConflicts.value = {
                message: error.response.data.message || '',
                items: error.response.data.data || []
            };
        } else {
            notifyError("Error", error.response?.data?.message || "Failed to send reschedule request. Please try again.");
        }
    }
};

onMounted(() => {
    fetchDetails();
});

</script>

<style scoped>
.teal-button-small {
    height: 30px;
    font-size: 0.75rem;
}

.detail-item {
    margin-bottom: 1rem;
}

.detail-item span {
    display: inline-block;
    margin-right: 1rem;
}

.capitalize {
    text-transform: capitalize;
}

.recurrence-grid {
    display: grid;
    grid-template-columns: max-content 1fr;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
    align-items: center;
}

.day-circle {
    width: 30px;
    height: 30px;
    color: var(--orange-500);
    border: 2px solid black;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    font-weight: 600;
}

.recurrence-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 12px;
}

.meet-link-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.meet-link-label {
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0 !important;
}

.meet-link-box {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
/** background: #eff6ff;
    border: 1px solid #bfdbfe; */
    border-radius: 8px;
    padding: 0.2rem 0.4rem;
    max-width: 100%;
    min-width: 0;
}

.meet-link {
    color: #3b82f6;
    text-decoration: none;
    font-size: 0.82rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.meet-link:hover {
    text-decoration: underline;
    color: #2563eb;
}

.copy-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: transparent;
    color: #93c5fd;
    border: none;
    border-radius: 4px;
    padding: 0;
    font-size: 0.8rem;
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.15s;
}

.copy-btn:hover {
    color: #3b82f6;
}

.copy-btn .pi-check {
    color: #22c55e;
}

@media (max-width: 600px) {
    .recurrence-grid {
        grid-template-columns: 1fr;
    }
        .meet-link-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.35rem;
    }

    .meet-link-label {
        white-space: normal;
    }

    .meet-link-box {
        width: 100%;
    }

    .meet-link {
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
    .teal-button-small {
        height: 30px;
        font-size: 0.75rem;
        white-space: nowrap;
        min-width: 140px;
    }
}
</style>